document.addEventListener("DOMContentLoaded", function () {
    // Get references to the input and anchor elements
    var email = document.getElementById("subscribeEmail");
    var subscribeLink = document.getElementById("subscribeLink");

    if (subscribeLink != null) {
        // Add a click event listener to the anchor

        subscribeLink.addEventListener("click", addEmailToNewsLetter);
        email.addEventListener("keyup", addEmailToNewsLetter);
    }
    function addEmailToNewsLetter(event) {
        if (event.type === "click" || (event.type === "keyup" && event.key === "Enter")) {
            event.preventDefault();

            var value = "Email=" + email.value; // Get the value from the input element
            var currentHref = subscribeLink.getAttribute("href"); // Get the current href
            var targetAttr = subscribeLink.getAttribute("target");

            if (currentHref.endsWith("?")) {
                var link = currentHref + value;
                window.open(link, targetAttr);
            } else {
                var link = currentHref + "?" + value;
                window.open(link, targetAttr);
            }
        }
    }
});